import {
  LayoutDashboard,
  Building2,
  List,
  History,
  FileText,
  CloudSnow,
  Award,
  CheckCircle,
  BarChart3,
  Files,
  FileSpreadsheet,
  Shield,
  Receipt,
  CreditCard,
  MessageCircle,
  Ticket
} from 'lucide-react'
import { SideLink } from './sidelinks'

export const clientLinks: SideLink[] = [
  {
    title: 'Dashboard',
    href: '/client-portal/dashboard',
    icon: <LayoutDashboard size={18} />,
  },
  {
    title: 'My Services',
    href: '/client-portal/services',
    icon: <Building2 size={18} />,
    sub: [
      {
        title: 'Services List',
        href: '/client-portal/services',
        icon: <List size={18} />,
      },
      {
        title: 'Service History',
        href: '/client-portal/services/history',
        icon: <History size={18} />,
      },
      {
        title: 'Service Requests',
        href: '/client-portal/service-requests',
        icon: <FileText size={18} />,
      },
      {
        title: 'Weather Alerts',
        href: '/client-portal/services/weather-alerts',
        icon: <CloudSnow size={18} />,
      }
    ],
  },
  {
    title: 'Quality & Inspections',
    href: '/client-portal/quality',
    icon: <Award size={18} />,
    sub: [
      {
        title: 'Inspection Sign-offs',
        href: '/client-portal/quality/inspections',
        icon: <CheckCircle size={18} />,
      },
      {
        title: 'Quality Reports',
        href: '/client-portal/quality/reports',
        icon: <BarChart3 size={18} />,
      }
    ],
  },
  {
    title: 'Documents',
    href: '/client-portal/documents',
    icon: <Files size={18} />,
    sub: [
      {
        title: 'Service Records',
        href: '/client-portal/service-records',
        icon: <FileSpreadsheet size={18} />,
      },
      {
        title: 'Compliance',
        href: '/client-portal/compliance',
        icon: <Shield size={18} />,
      }
    ],
  },
  {
    title: 'Invoices',
    href: '/client-portal/invoices',
    icon: <Receipt size={18} />,
    sub: [
      {
        title: 'List',
        href: '/client-portal/invoices',
        icon: <CreditCard size={18} />,
      },
    ],
  },
  {
    title: 'Support',
    href: '/client-portal/support',
    icon: <MessageCircle size={18} />,
    sub: [
      {
        title: 'Tickets',
        href: '/client-portal/support',
        icon: <Ticket size={18} />,
      },
    ],
  },
]